document.addEventListener('DOMContentLoaded', function () {
  /* ---------------------------------------
     Mobile menu toggle
  --------------------------------------- */
  var menuToggle = document.querySelector('.header-menu-toggle');
  var nav = document.getElementById('HeaderNav');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ---------------------------------------
     Search toggle
  --------------------------------------- */
  var searchToggle = document.querySelector('.header-search-toggle');
  var searchPanel = document.getElementById('HeaderSearch');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var willShow = searchPanel.hasAttribute('hidden');
      if (willShow) {
        searchPanel.removeAttribute('hidden');
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      } else {
        searchPanel.setAttribute('hidden', '');
      }
      searchToggle.setAttribute('aria-expanded', willShow);
    });
  }

  /* ---------------------------------------
     Product media gallery
  --------------------------------------- */
  var mainImage = document.getElementById('ProductMainImage');
  var thumbs = document.querySelectorAll('.product-media__thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function (e) {
      e.preventDefault();
      if (!mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = thumb.getAttribute('data-image-src');
      mainImage.alt = thumb.getAttribute('data-image-alt') || '';
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------------------------------------
     Quantity stepper (- / +)
  --------------------------------------- */
  document.querySelectorAll('.quantity-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('.quantity-stepper__input');
    var minusBtn = stepper.querySelector('.quantity-stepper__btn--minus');
    var plusBtn = stepper.querySelector('.quantity-stepper__btn--plus');
    if (!input) return;

    function clampToMax(val) {
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var maxAttr = input.getAttribute('max');
      var max = (maxAttr !== null && maxAttr !== '') ? parseInt(maxAttr, 10) : null;
      if (isNaN(val) || val < min) val = min;
      if (max !== null && !isNaN(max) && val > max) val = max;
      return val;
    }

    function step(delta) {
      var current = parseInt(input.value, 10);
      if (isNaN(current)) current = parseInt(input.getAttribute('min'), 10) || 1;
      var next = clampToMax(current + delta);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (minusBtn) minusBtn.addEventListener('click', function () { step(-1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { step(1); });

    input.addEventListener('change', function () {
      var val = clampToMax(parseInt(input.value, 10));
      input.value = val;
    });
  });

  /* ---------------------------------------
     Product variant picker (swatch-knoppen i.p.v. dropdown)
  --------------------------------------- */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    var variantsJsonEl = document.getElementById('ProductVariantsJson');
    var variants = [];
    try { variants = JSON.parse(variantsJsonEl.textContent); } catch (e) { variants = []; }

    var inventoryEl = document.getElementById('ProductVariantInventory');
    var inventoryMap = {};
    try { inventoryMap = JSON.parse(inventoryEl.textContent); } catch (e) { inventoryMap = {}; }

    var colorImagesEl = document.getElementById('ProductColorImages');
    var colorImages = {};
    try { colorImages = JSON.parse(colorImagesEl.textContent); } catch (e) { colorImages = {}; }

    var optionGroups = productForm.querySelectorAll('.option-swatches');
    var variantIdInput = document.getElementById('ProductVariantId');
    var priceEl = document.getElementById('ProductPrice');
    var addBtn = document.getElementById('ProductAddToCart');
    var addBtnText = document.getElementById('ProductAddToCartText');
    var qtyInput = document.getElementById('ProductQuantity');

    function currentOptions() {
      var opts = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.option-swatch.is-active');
        opts.push(active ? active.getAttribute('data-value') : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        var values = [v.option1, v.option2, v.option3].filter(function (x) { return x !== null && x !== undefined; });
        return opts.every(function (val, i) { return values[i] === val; });
      });
    }

    function formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function applyInventoryCap(variant) {
      if (!qtyInput || !variant) return;
      var cap = inventoryMap[String(variant.id)];
      if (cap === null || cap === undefined) {
        qtyInput.removeAttribute('max');
        return;
      }
      var max = cap > 0 ? cap : 0;
      qtyInput.setAttribute('max', max);
      var current = parseInt(qtyInput.value, 10);
      if (isNaN(current) || current > max) {
        qtyInput.value = max > 0 ? max : 1;
      }
    }

    function swapImageForColor(colorValue) {
      if (!mainImage || !colorValue) return;
      var url = colorImages[colorValue];
      if (!url) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = url;
      mainImage.alt = colorValue;

      // Zet de bijbehorende thumbnail (indien aanwezig) ook op actief
      thumbs.forEach(function (t) {
        var tSrc = (t.getAttribute('data-image-src') || '').split('?')[0];
        var matches = tSrc && url.indexOf(tSrc.replace(/^https?:/, '')) !== -1;
        t.classList.toggle('is-active', !!matches);
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="product-card__price--compare">' + formatMoney(variant.compare_at_price) + '</span>' +
            '<span class="product-card__price--sale">' + formatMoney(variant.price) + '</span>';
        } else {
          priceEl.innerHTML = '<span>' + formatMoney(variant.price) + '</span>';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
      }
      if (addBtnText) {
        addBtnText.textContent = variant.available ? window.THEME_STRINGS.addToCart : window.THEME_STRINGS.soldOut;
      }
      applyInventoryCap(variant);
    }

    optionGroups.forEach(function (group) {
      var buttons = group.querySelectorAll('.option-swatch');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-active')) return;
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var variant = findVariant(currentOptions());
          updateForVariant(variant);

          var value = btn.getAttribute('data-value');
          if (colorImages[value]) {
            swapImageForColor(value);
          }
        });
      });
    });

    // Cap toepassen voor de initieel geselecteerde variant bij het laden van de pagina
    if (variantIdInput) {
      var initialVariant = variants.find(function (v) { return String(v.id) === String(variantIdInput.value); });
      if (initialVariant) applyInventoryCap(initialVariant);
    }

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var errorEl = document.getElementById('ProductFormError');
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

      var formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok || result.data.status) {
            var msg = (result.data && (result.data.description || result.data.message)) ||
              'Er kon niet de volledige hoeveelheid worden toegevoegd vanwege beschikbare voorraad.';
            if (errorEl) {
              errorEl.textContent = msg;
              errorEl.hidden = false;
            }
          }
          refreshCart(true);
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          if (errorEl) {
            errorEl.textContent = 'Er ging iets mis bij het toevoegen aan je winkelwagen. Probeer het opnieuw.';
            errorEl.hidden = false;
          }
        });
    });
  }

  /* ---------------------------------------
     Cart drawer / cart page interactions
  --------------------------------------- */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartIconTrigger = document.getElementById('CartIconTrigger');
  var cartDrawerClose = document.getElementById('CartDrawerClose');
  var cartDrawerOverlay = document.getElementById('CartDrawerOverlay');
  var isDrawerMode = !!cartDrawer;

  function openDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  if (isDrawerMode && cartIconTrigger) {
    cartIconTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart(false);
      openDrawer();
    });
  }
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeDrawer);

  function formatMoneyCents(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function renderDrawer(cart) {
    var body = document.getElementById('CartDrawerBody');
    var footer = document.getElementById('CartDrawerFooter');
    var subtotalEl = document.getElementById('CartDrawerSubtotal');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty-msg">' + window.THEME_STRINGS.empty + '</p>';
      if (footer) footer.hidden = true;
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      html += '<div class="cart-drawer-item" data-key="' + item.key + '">';
      html += '<img src="' + (item.image || '') + '" alt="' + (item.product_title || '') + '" width="64" height="64">';
      html += '<div>';
      html += '<div class="cart-drawer-item__title">' + item.product_title + '</div>';
      if (item.variant_title) {
        html += '<div class="cart-drawer-item__variant">' + item.variant_title + '</div>';
      }
      html += '<div class="cart-drawer-item__qty-row">';
      html += '<input type="number" class="cart-drawer-item__qty" min="0" value="' + item.quantity + '" data-key="' + item.key + '">';
      html += '<span class="cart-drawer-item__price">' + formatMoneyCents(item.final_line_price) + '</span>';
      html += '<button type="button" class="cart-drawer-item__remove" data-key="' + item.key + '" aria-label="Verwijderen">&times;</button>';
      html += '</div></div></div>';
    });
    body.innerHTML = html;

    if (footer) {
      footer.hidden = false;
      if (subtotalEl) subtotalEl.textContent = formatMoneyCents(cart.total_price);
    }

    body.querySelectorAll('.cart-drawer-item__qty').forEach(function (input) {
      input.addEventListener('change', function () {
        updateLineByKey(input.getAttribute('data-key'), input.value);
      });
    });
    body.querySelectorAll('.cart-drawer-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateLineByKey(btn.getAttribute('data-key'), 0);
      });
    });
  }

  function refreshCart(openAfter) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.getElementById('CartCount');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.classList.toggle('is-hidden', cart.item_count === 0);
        }
        if (isDrawerMode) {
          renderDrawer(cart);
          if (openAfter) openDrawer();
        }
      })
      .catch(function (err) { console.error('Cart refresh failed', err); });
  }

  function updateLineByKey(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: parseInt(quantity, 10) })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.getElementById('CartCount');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.classList.toggle('is-hidden', cart.item_count === 0);
        }
        if (isDrawerMode) renderDrawer(cart);
        var cartForm = document.getElementById('CartForm');
        if (cartForm) window.location.reload();
      })
      .catch(function (err) { console.error('Cart update failed', err); });
  }

  /* Cart page (non-drawer) quantity / remove */
  var cartTable = document.querySelector('.cart-table');
  if (cartTable) {
    cartTable.querySelectorAll('.cart-table__qty').forEach(function (input) {
      input.addEventListener('change', function () {
        var line = input.getAttribute('data-line');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) })
        }).then(function () { window.location.reload(); });
      });
    });
    cartTable.querySelectorAll('.cart-table__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.getAttribute('data-line');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
        }).then(function () { window.location.reload(); });
      });
    });
  }

  /* Initial cart count sync (in case of cache) */
  refreshCart(false);
});

window.THEME_STRINGS = window.THEME_STRINGS || {
  addToCart: 'In winkelwagen',
  soldOut: 'Uitverkocht',
  empty: 'Je winkelwagen is leeg'
};

/* ---------------------------------------
   Subtle fade-in on scroll
--------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  var revealEls = document.querySelectorAll('.reveal-on-scroll');
  if (!revealEls.length) return;

  if (!('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  revealEls.forEach(function (el) { observer.observe(el); });
});
